module.exports = __webpack_public_path__ + "static/1-6eb2b4bacb68254f7c0511e547004597.jpeg";